module.exports = __webpack_public_path__ + "img/logo.9f6e6bd3.png";